import {
	Document,
	Page,
	Text,
	View,
	StyleSheet,
	Image,
} from "@react-pdf/renderer";
import Logo from "../../Assets/Images/Logo2.png";

const styles = StyleSheet.create({
	page: {
		flexDirection: "column",
		backgroundColor: "#FFFFFF",
		padding: 20,
		fontSize: 10,
		fontFamily: "Helvetica",
	},
	header: {
		flexDirection: "row",
		justifyContent: "space-between",
		alignItems: "center",
		marginBottom: 20,
		paddingBottom: 10,
		borderBottom: "1 solid #E0E0E0",
	},
	logo: { width: 100.5, height: 20 },
	title: { fontSize: 18, fontWeight: "extrabold", color: "#0E3465" },
	section: {
		marginBottom: 15,
		padding: 10,
		backgroundColor: "#EDF2F6",
		borderTop: "1 solid #14B8FF",
		borderRadius: 5,
	},
	sectionTitle: {
		fontSize: 12,
		fontWeight: "bold",
		marginBottom: 8,
		color: "#0E3465",
		padding: 5,
		borderRadius: 3,
	},
	infoGrid: { flexDirection: "row", flexWrap: "wrap", gap: 10 },
	infoItem: { flexDirection: "row", marginBottom: 5, minWidth: "48%" },
	infoLabel: { fontWeight: "bold", minWidth: 80, color: "#555" },
	infoValue: { flex: 1, color: "#333" },
	summaryText: { marginBottom: 8, lineHeight: 1.4, textAlign: "justify" },
	materialsTable: { flexDirection: "column" },
	tableRow: {
		flexDirection: "row",
		borderBottom: "1 solid #DDD",
		paddingVertical: 5,
	},
	tableCell: { flex: 1, paddingHorizontal: 8, paddingVertical: 4 },
	photo: { width: "100%", height: 200, objectFit: "cover", borderRadius: 3 },
	photoLabel: {
		fontSize: 10,
		textAlign: "center",
		marginTop: 5,
		color: "#666",
	},
});

const PdfDoc = ({ report, survey, logo }) => {
	return (
		<Document>
			<Page size="A4" style={styles.page}>
				<View style={styles.header}>
					<Image style={styles.logo} src={Logo} />
					<Text style={styles.title}>Site Survey Report</Text>
				</View>

				<View>
					<Text style={styles.sectionTitle}>General Information</Text>
					<View style={styles.section}>
						<View style={styles.infoGrid}>
							<View style={styles.infoItem}>
								<Text style={styles.infoLabel}>Service Type:</Text>
								<Text style={styles.infoValue}>{survey?.service}</Text>
							</View>
							<View style={styles.infoItem}>
								<Text style={styles.infoLabel}>Job ID:</Text>
								<Text style={styles.infoValue}>{survey?.jobNumber}</Text>
							</View>
							<View style={styles.infoItem}>
								<Text style={styles.infoLabel}>Company Name:</Text>
								<Text style={styles.infoValue}>{survey?.company}</Text>
							</View>
							<View style={styles.infoItem}>
								<Text style={styles.infoLabel}>Location:</Text>
								<Text style={styles.infoValue}>{survey?.location}</Text>
							</View>
							<View style={styles.infoItem}>
								<Text style={styles.infoLabel}>Email:</Text>
								<Text style={styles.infoValue}>{survey?.email}</Text>
							</View>
							<View style={styles.infoItem}>
								<Text style={styles.infoLabel}>Phone Number:</Text>
								<Text style={styles.infoValue}>{survey?.phoneNumber}</Text>
							</View>
						</View>
					</View>
				</View>

				<View>
					<Text style={styles.sectionTitle}>Feasibility Summary</Text>
					<View style={styles.section}>
						<Text style={styles.summaryText}>
							{report?.feasibilitySummary?.summary}
						</Text>
					</View>
				</View>

				<View>
					<Text style={styles.sectionTitle}>Required Materials</Text>
					<View style={styles.section}>
						<View style={styles.materialsTable}>
							{report?.requiredMaterials?.map((material, index) => (
								<View key={index} style={styles.tableRow}>
									<Text style={styles.tableCell}>{material.item}</Text>
								</View>
							))}
						</View>
					</View>
				</View>

				{report?.photos?.[0] && (
					<View>
						<Text style={styles.sectionTitle}>Report Image</Text>
						<View style={{ marginBottom: 15 }}>
							<Image style={styles.photo} src={report.photos[0]} />
						</View>
					</View>
				)}
			</Page>
		</Document>
	);
};

export default PdfDoc;
